<script setup lang="ts">
import { t } from '@/i18n';
import { CheckCircle2, AlertCircle, Info, X } from '@lucide/vue';
import { useToast } from '@/composables/useToast';
const {messages,remove,pause,resume}=useToast();
</script>
<template>
  <TransitionGroup name="notification" tag="div" class="toast-host">
    <div v-for="toast in messages" :key="toast.id" class="toast" :class="toast.kind" :role="toast.kind==='error'?'alert':'status'" @mouseenter="pause(toast.id)" @mouseleave="resume(toast.id)" @focusin="pause(toast.id)" @focusout="resume(toast.id)">
      <CheckCircle2 v-if="toast.kind==='success'" aria-hidden="true"/>
      <AlertCircle v-else-if="toast.kind==='error'" aria-hidden="true"/>
      <Info v-else aria-hidden="true"/>
      <span>{{toast.message}}</span>
      <button class="icon-btn" :aria-label="t('common.closeNotification')" @click="remove(toast.id)"><X aria-hidden="true"/></button>
    </div>
  </TransitionGroup>
</template>
